/* eslint-disable react-hooks/rules-of-hooks */
import { useQuery } from "react-query";
import { DATACENTRAL_API_URL, SERVICE_API_URL } from "../utils/constants";
import { requestWithToken } from "../utils/functions";

export function resolveCustomer() {
  return useQuery("customerInformation", async () => {
    try {
      const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/segment/info`)

      return response?.data?.data?.customer
    } catch(exception) {
      console.log(exception);

      return null
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    enabled: typeof localStorage.getItem('SA') !== "undefined",
    suspense: true
  })
}

export async function createCustomer(payload: any) {
  const response = await fetch(`${DATACENTRAL_API_URL}/workers/v2/customers`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })

  return await response.json()
}

export async function updateCustomer(id: number, payload: any) {
  const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/customers/${id}`, 'PATCH', payload)

  return response?.data
}

export function resolveCustomerTeam(user: any) {
  return useQuery(["user.team", user?.email], async () => {
    try {
      const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${user?.email}`)

      return response?.data?.data?.team
    } catch (exception) {
      console.log(exception)
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    enabled: typeof user?.email !== "undefined" || typeof localStorage.getItem('SA') !== "undefined",
    suspense: true
  })
}

export async function createCustomerTeam(payload: any) {
  const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams`, 'POST', payload)

  return response?.data?.data?.team
}

export function resolveCustomerTeamMember(team: any) {
  return useQuery(["customer.team.members", team?.owner], async () => {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${team?.owner}/teammates`)

    return response?.data?.data
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    enabled: typeof team !== "undefined" && typeof localStorage.getItem('SA') !== "undefined",
    suspense: true
  })
}

export async function resendTeamInvitation(owner: string, id: string) {
  const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${owner}/teammates/${id}/invitation`, 'POST')

  return response?.data?.data?.member
}

export async function removeTeamMember(owner: string, id: string) {
  const response = await requestWithToken(`${SERVICE_API_URL}/v2/teams/${owner}/teammates/${id}`, 'DELETE')

  return response?.data?.data?.teammates
}

export function getCustomerVerificationSteps() {
  return useQuery("account.customer.verification", async () => {
    try {
      const response = await requestWithToken(`${SERVICE_API_URL}/v2/segment`)

      return response?.data?.data
    } catch (exception: any) {
      return null
    }
  }, {
    refetchOnWindowFocus: true,
    keepPreviousData: false,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: typeof localStorage.getItem('SA') !== "undefined"
  })
}

export async function submitCustomerVerificationSteps(payload: any) {
  const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/segment/verification_submit`, 'POST', payload)

  return response?.data?.data
}

export function getCustomerBillingInvoice(customer: any) {
  return useQuery(["account.customer.invoices", customer?.customer_id], async () => {
    try {
      const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/invoices`)

      return response?.data?.data?.invoices?.sort((a: any, b: any) => b.invoice_id - a.invoice_id)?.map((item: any) => ({
        ...item,
        id: item.invoice_id
      })) || []
    } catch (exception: any) {
      return []
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: typeof customer?.customer_id !== "undefined" && typeof localStorage.getItem('SA') !== "undefined"
  })
}

export function getCustomerBillingInvoiceDetail(invoice_id: string | undefined) {
  return useQuery(["account.customer.invoices", invoice_id], async () => {
    try {
      const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/invoices/${invoice_id}`)

      return response?.data?.data?.invoice
    } catch (exception: any) {
      return {}
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: typeof invoice_id !== "undefined" && typeof localStorage.getItem('SA') !== "undefined"
  })
}

export function getCustomerPaymentMethods({ customer_id }: any) {
  return useQuery(["account.customer.payment_methods", customer_id], async () => {
    try {
      const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/payments`)

      return response?.data?.data?.methods
    } catch (exception: any) {
      return []
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: typeof customer_id !== "undefined" && typeof localStorage.getItem('SA') !== "undefined"
  })
}